import "regenerator-runtime/runtime";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { createTracker } from "@elastic/behavioral-analytics-javascript-tracker";

const connector = new AppSearchAPIConnector({
  searchKey: "search-1gvrkpfv9a9px3z2w14jp4k3",
  engineName: "engine-public-courses-majors",
  endpointBase: "https://murdoch-university.ent.australiaeast.azure.elastic-cloud.com",
  cacheResponses: false
});

// course finder API
createTracker({
  endpoint: "https://7482b89b357c4ef490c211d9da5893e4.australiaeast.azure.elastic-cloud.com:443",
  collectionName: "course-finder",
  apiKey: "R2dmTm5JNEJBYzg2NDctaEtGZ0w6eU04OWhUZ29TdU82ZjQxVVdoNE0wdw=="
});

const config = {
  debug: true,
  apiConnector: connector,
  searchQuery: {
    disjunctiveFacets: ["study_level", "curriculum_item_type", "study_area"],
    facets: {
      study_level: {
        type: "value"
      },
      curriculum_item_type: {
        type: "value"
      },
      study_area: {
        type: "value",
        size: 17
        //sort: { "value" : "asc" }
      }
    }
  },
  autocompleteQuery: {
    // performs a prefix search on the query
    results: {
      resultsPerPage: 5, // number of results to display. Default is 5.
      result_fields: {
        // Add snippet highlighting within autocomplete suggestions
        title: { snippet: { size: 100, fallback: true } }
      }
    },
    // performs a query to suggest for values that partially match the incomplete query
    suggestions: {
      types: {
        // Limit query to only suggest based on "title" field
        documents: { fields: ["title"] }
      },
      // Limit the number of suggestions returned from the server
      size: 4
    }
  }
};

export default config;